import { ReusableNotesField } from './ReusableNotesField';
import { useField } from 'react-final-form';
import { useUpdateCheckbox } from 'pages/ListerVehicleUploadV2/hooks/useUpdateCheckbox';
import { parsePath } from './utils';

type Props = {
  sectionId: string;
};

export const FinalReviewCheckboxNotes = ({ sectionId }: Props) => {
  const [section, index] = parsePath(sectionId);

  const {
    input: { value: checkboxId }
  } = useField(`${sectionId}.id`);
  const [updateCheckbox] = useUpdateCheckbox(checkboxId, section, index);

  const save = async (notes: string | null, fieldName = 'notes') => {
    updateCheckbox({
      [fieldName]: notes
    });
  };

  return <ReusableNotesField autoFocus={false} save={save} sectionId={sectionId} />;
};
